module.exports = __webpack_public_path__ + "static/media/foundation.6d88f2c7.png";